import React from "react";

type CheckboxGroupState = {
  /**
   * Whether the checkbox group should be horizontally aligned.
   */
  horizontal: boolean;
};

const CheckboxGroupStateContext = React.createContext<CheckboxGroupState | null>(null);

CheckboxGroupStateContext.displayName = "CheckboxGroupState";

export const useCheckboxGroupState = (): CheckboxGroupState => {
  return React.useContext(CheckboxGroupStateContext) ?? { horizontal: false };
};

export const CheckboxGroupStateProvider: React.FC<CheckboxGroupState> = (props) => {
  return <CheckboxGroupStateContext.Provider value={props}>{props.children}</CheckboxGroupStateContext.Provider>;
};

CheckboxGroupStateProvider.displayName = "CheckboxGroupStateProvider";
